export default {
  BAN_USER: "BAN_USER",
  CANCEL_TRANSACTIONS: "CANCEL_TRANSACTIONS",
  CONFIRM_TRANSACTIONS: "CANCEL_TRANSACTIONS",
};
  